import { render } from "./UnitTypeList.vue?vue&type=template&id=0b66d67f&scoped=true"
import script from "./UnitTypeList.vue?vue&type=script&lang=js"
export * from "./UnitTypeList.vue?vue&type=script&lang=js"

import "./UnitTypeList.vue?vue&type=style&index=0&id=0b66d67f&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b66d67f"]])

export default __exports__